import type { Enum } from "@/types/index.ts";

export const SmartNumberDescriptor = {
    SubFamily: "SUBFAMILY",
    BeamAngle: "BEAMANGLE",
    CCT: "CCT",
    CRI: "CRI",
    DimType: "DIMTYPE",
    LEDChip: "LEDCHIP",
    LightDistributor: "LIGHTDISTRIBUTOR",
    Accessory: "S39_ACCESSORY",
    Dimension: "S39_DIMENSION",
    MountingKit: "S39_MOUNTING",
    PowerSupply: "S39_POWER",
    Separator: "SEPARATOR",
} as const;
export type SmartNumberDescriptorKey = Enum<typeof SmartNumberDescriptor>;
